import {i18n2} from 'features/i18n/i18n';
import * as yup from 'yup';

export const CourseSchema = (noIntegrity = null, noSpac = null) => {
  const course = yup.object({
    iD_Course: yup.number().label(i18n2._('ID')),
    doc_Number: yup
      .string()
      .required(i18n2._('Este campo es obligatorio'))
      .max(60)
      .label(i18n2._('Documento')),
    name: yup
      .string()
      .required(i18n2._('Este campo es obligatorio'))
      .max(255)
      .label(i18n2._('Nombre')),
    content: yup.string().max(255).label(i18n2._('Contenido')),
    status: yup.number().label(i18n2._('Estado')),
    iD_Type: yup
      .string()
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Tipo')),
    company: yup
      .string()
      .required(i18n2._('Este campo es obligatorio'))
      .max(50)
      .label(i18n2._('Compañía')),
    dateVig: yup
      .date()
      .required(i18n2._('Este campo es obligatorio'))
      .typeError(i18n2._('Ingrese una fecha correcta'))
      .nullable(true)
      .label(i18n2._('Fecha de Vigencia')),
    version: yup
      .number()
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Version')),
    score: yup
      .number()
      .typeError(i18n2._('Ingrese un número correcto'))
      .required(i18n2._('Este campo es obligatorio'))
      .default(70)
      .label(i18n2._('Puntaje necesario')),
    iD_Parent: yup.number().label(i18n2._('#ID Anterior')),
  });

  const spac = yup.object({
    spac: yup.string().max(4).label(i18n2._('Spac')),
  });

  const Integrity = yup.object({
    revision: yup.number().label(i18n2._('Revision')),
    reason: yup
      .string()
      .max(255)
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Motivo')),
    updateDate: yup.date().label(i18n2._('Fecha de actualizacion')),
    updatedBy: yup.string().label(i18n2._('Actualizado por')),
    deleted: yup.boolean().label(i18n2._('Eliminado')),
  });

  let finalSchema = course;
  if (noSpac === null) {
    finalSchema = spac.concat(finalSchema);
  }
  if (noIntegrity === null) {
    finalSchema = Integrity.concat(finalSchema);
  }

  return finalSchema;
};
